import React, { useEffect, useState } from 'react';
import { useSelector } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { AppInput, AppNotificationAlert, AppRemixIcon } from '@/layout/AppComponents';
import axios from 'axios';
import ReactDOMServer from 'react-dom/server';
import {QRCodeSVG} from 'qrcode.react';
import { Formik } from 'formik';
import Translator from '../../layout/components/helpers/Translator';
import BreadcrumbHandler from '../../layout/components/breadcrumb/BreadcrumbHandler';
import { axiosPath, path } from '../../routing/helpers/router';

const DoubleAuthentication = () => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth?.user);
  const doubleAuth = useSelector(
    (state) => state?.auth?.permissions?.client?.global?.doubleAuth
  );
  const [qrCode, setQrCode] = useState(null);
  const urlData = useSelector((state) => state.global?.urlData);

  useEffect(() => {
    if (doubleAuth === undefined || !doubleAuth)
      navigate(path({ name: "user_home" }));
  }, []);

  const generateNewQrCode = async (values) => {
    await axios
      .get(axiosPath("api_r_user_authUser_setAuthUserTwoFactor"), values)
      .then((response) => {
        setQrCode(response.data);
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          AppNotificationAlert({
            title: "Error",
            message: err.response.data.message,
            type: "danger",
            duration: 3000,
          });
        }
      });
  };

  const verifyAuthCode = async (values) => {
    await axios
      .post(
        axiosPath("api_r_user_authUser_verifyCodeAuthUserTwoFactor"),
        values
      )
      .then(({ data }) => {
        if (data.check) {
          window.location = urlData.rootProject;
          AppNotificationAlert({
            title: "Verificación",
            message: "Se ha verificado correctamente tu cuenta",
            type: "success",
            duration: 3000,
          });
          return;
        }

        AppNotificationAlert({
          title: "Verificación",
          message: "Código de verificación incorrecto",
          type: "warning",
          duration: 3000,
        });
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          AppNotificationAlert({
            title: "Error",
            message: err.response.data.message,
            type: "danger",
            duration: 3000,
          });
        }
      });
  };

  const disableAuthCode = async () => {
    await axios
      .get(axiosPath("api_r_user_authUser_disableCodeAuthUserTwoFactor"), {})
      .then(() => {
        window.location = urlData.rootProject;
      })
      .catch((err) => {
        if (err?.response?.data?.message) {
          AppNotificationAlert({
            title: "Error",
            message: err.response.data.message,
            type: "danger",
            duration: 3000,
          });
        }
      });
  };

  return (
    <section className="relative m_sr p-3">
      <div className="content-header">
        <BreadcrumbHandler
          paths={[
            {
              name: ReactDOMServer.renderToString(
                <Translator file="user" name="double-authentication" />
              ),
            },
          ]}
        />
      </div>
      <section className="content">
        <div className="row">
          <div className="col-sm-12 col-md-6 col-lg-4 offset-md-3 offset-lg-4">
            <div className="card">
              <div className="card-header">
                <Translator file="user" name="double-authentication" />
              </div>
              <div className="card-body">
                {user.googleAuthenticatorSecret ? (
                  <div>
                    {qrCode ? (
                      <div
                        style={{
                          textAlign: "center",
                        }}
                      >
                        <QRCodeSVG value={qrCode} size={200} className="mb-2" />
                        <Translator
                          file="user"
                          name="general.scan-code-google-authenticator-app"
                          isHtml
                        />
                        <div className="mt-2">
                          <Formik
                            initialValues={{
                              code: "",
                            }}
                            validateOnChange={false}
                            validateOnBlur={false}
                            onSubmit={verifyAuthCode}
                          >
                            {({
                              setFieldValue,
                              handleSubmit,
                              values,
                              isSubmitting,
                            }) => (
                              <form onSubmit={handleSubmit}>
                                <div
                                  style={{
                                    textAlign: "justify",
                                  }}
                                >
                                  <AppInput
                                    title={ReactDOMServer.renderToString(
                                      <Translator
                                        file="user"
                                        name="enter-verification-code"
                                      />
                                    )}
                                    icon={<AppRemixIcon icon="shield-check" />}
                                    value={values.code}
                                    onChange={(v) => setFieldValue("code", v)}
                                    required
                                    isClearable
                                  />
                                  <div className="mt-3">
                                    <button
                                      type="submit"
                                      className="btn btn-block btn-outline-light"
                                      onClick={verifyAuthCode}
                                      disabled={isSubmitting}
                                    >
                                      <Translator file="user" name="verify" />
                                    </button>
                                    <span
                                      className="btn btn-block btn-outline-light"
                                      onClick={disableAuthCode}
                                    >
                                      Desactivar verificación
                                    </span>
                                  </div>
                                </div>
                              </form>
                            )}
                          </Formik>
                        </div>
                      </div>
                    ) : (
                      <div>
                        <Translator
                          file="user"
                          name="general.two-factor-authentication-enabled"
                          isHtml
                        />
                        <br />
                        <br />
                        <a
                          href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=es"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <Translator
                            file="user"
                            name="general.application-android"
                          />
                        </a>
                        <br />
                        <a
                          href="https://apps.apple.com/us/app/google-authenticator/id388497605"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <Translator
                            file="user"
                            name="general.application-ios"
                          />
                        </a>
                        <div className="mt-3">
                          <span
                            className="btn btn-block btn-outline-light"
                            onClick={generateNewQrCode}
                          >
                            <Translator
                              file="user"
                              name="general.re-synchronise"
                            />
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <div>
                    {qrCode ? (
                      <div
                        style={{
                          textAlign: "center",
                        }}
                      >
                        <QRCode value={qrCode} size={200} className="mb-2" />
                        <Translator
                          file="user"
                          name="general.scan-code-google-authenticator-app"
                          isHtml
                        />
                        <div className="mt-10">
                          <Formik
                            initialValues={{
                              code: "",
                            }}
                            validateOnChange={false}
                            validateOnBlur={false}
                            onSubmit={verifyAuthCode}
                          >
                            {({
                              setFieldValue,
                              handleSubmit,
                              values,
                              isSubmitting,
                            }) => (
                              <form onSubmit={handleSubmit}>
                                <div
                                  style={{
                                    textAlign: "justify",
                                  }}
                                >
                                  <AppInput
                                    title={ReactDOMServer.renderToString(
                                      <Translator
                                        file="user"
                                        name="enter-verification-code"
                                      />
                                    )}
                                    icon={<AppRemixIcon icon="shield-check" />}
                                    value={values.code}
                                    onChange={(v) => setFieldValue("code", v)}
                                    required
                                    isClearable
                                  />
                                  <div className="mt-3">
                                    <button
                                      type="submit"
                                      className="btn btn-block btn-outline-light"
                                      onClick={verifyAuthCode}
                                      disabled={isSubmitting}
                                    >
                                      <Translator file="user" name="verify" />
                                    </button>
                                    <span
                                      className="btn btn-block btn-outline-light"
                                      onClick={disableAuthCode}
                                    >
                                      Desactivar verificación
                                    </span>
                                  </div>
                                </div>
                              </form>
                            )}
                          </Formik>
                        </div>
                      </div>
                    ) : (
                      <div>
                        <Translator
                          file="user"
                          name="general.attention-clicking-generate-qr-protected-double-authentication"
                          isHtml
                        />
                        <br />
                        <br />
                        <a
                          href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=es"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <Translator
                            file="user"
                            name="general.application-android"
                          />
                        </a>
                        <br />
                        <a
                          href="https://apps.apple.com/us/app/google-authenticator/id388497605"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <Translator
                            file="user"
                            name="general.application-ios"
                          />
                        </a>
                        <div className="mt-3">
                          <span
                            className="btn btn-block btn-outline-light"
                            onClick={generateNewQrCode}
                          >
                            <Translator
                              file="user"
                              name="general.generate-qr-code"
                            />
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </section>
  );
};

export default DoubleAuthentication;
